<div #notification>
  <mat-card
    appearance="outlined"
    class="fixed-notification {{ status }}"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="16px"
  >
    <div
      (click)="emitNotification()"
      fxFlex
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <mat-icon class="notification-icon {{ status }} mr-3 ">error</mat-icon>
      <div class="text" fxLayout="column">
        <p class="fs-16 fw-m fc-3" [innerHTML]="title | translate"></p>
        <span
          class="fs-14 fw-m fc-9"
          mat-icon-button
          fxHide.sm
          fxHide.xs
          fxShow
          >{{ description | translate }}</span
        >
      </div>
      <mat-icon class="ml-1 ic-svg-9" fxHide fxShow.sm fxShow.xs
        >chevron_right</mat-icon
      >
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="14px" *ngIf="button">
      <button
        (click)="emitNotification()"
        class="{{ status }}"
        mat-flat-button
        color="primary"
        fxHide.sm
        fxHide.xs
        fxShow
      >
        {{ button | translate }}
      </button>
    </div>
    <button (click)="closeNotification()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </mat-card>
</div>
